import { render, staticRenderFns } from "./OzellikKapaliView.vue?vue&type=template&id=00a62658&scoped=true"
import script from "./OzellikKapaliView.vue?vue&type=script&lang=ts"
export * from "./OzellikKapaliView.vue?vue&type=script&lang=ts"
import style0 from "./OzellikKapaliView.vue?vue&type=style&index=0&id=00a62658&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a62658",
  null
  
)

export default component.exports